import React, {
  useContext,
  useEffect
} from 'react';

import {
  withRouter
} from 'react-router-dom';

import {
  Heading,
  Text,
  RedButton
} from 'src/StyledComponents';

import NewCustomerBack from 'src/Components/Common/NewCustomerBack/NewCustomerBack';

import {
  PassportLogo,
  SaWorkPermitLogo
} from 'src/Components/Common/Svg';

import {
  SalesContext
} from 'src/Context/SalesContext';

import {
  tagOnNotesPageLoadId,
  tagOnNotesPageLoadPassport
} from 'src/Tagging/NewCustomerTagging';

import {
  addBeforeloadEvent,
  removeBeforeloadEvent
} from 'src/Utility/utility';

import CallMeBackForm from 'src/Components/Common/CallMeBackForm/CallMeBackForm';

import DocumentNoteItem from './Components/DocumentNoteItem';

import './NewCustomerDocumentNotes.css';

const NewCustomerDocumentNotes = (props) => {

  const context = useContext(SalesContext);

  const nextButtonClickHandler = () => {
    // To delete the new customer details moving from IdPassport Page to credit vetting page
    // context.setVettingDetails(null);
    props.history && props.history.push('/cloud/fibre/sales/credit-vetting');
  };

  const selectedDocument =
    context?.employmentDetails?.selectedIdTab === 'passportNumber'
      ? 'passport'
      : 'SA ID';

  useEffect(() => {
    addBeforeloadEvent();

    return () => {
      removeBeforeloadEvent();
    };
  }, []);

  useEffect(()=>{
    if (selectedDocument === 'passport'){
      tagOnNotesPageLoadPassport();
    }else{
      tagOnNotesPageLoadId();
    }
  }, []);

  return (
    <div className="vetting-docs-wrapper">

      <NewCustomerBack
        title="Back"
        backUrl="/cloud/fibre/sales/deliveryAddress"
      />

      <div className="new-customer-notes__container">

        <div className="customer-notes_left-section">

          <Heading>Before we get started...</Heading>
          <Text>
            {'You\'ll need to provide the following:'}
          </Text>

          <div className="new-customer-notes__docs-wrapper">

            <DocumentNoteItem
              title={'Copy of your ' + selectedDocument}
              Logo={PassportLogo}
            />

            {selectedDocument === 'passport' && (
              <DocumentNoteItem title="SA work permit" Logo={SaWorkPermitLogo} />
            )}
          </div>

          <Text fontSize="14px">
            Please note: These documents are <b>not required</b> if you are a{' '}
            <b>student, contractor or unemployed.</b>
          </Text>

          <br />
          <RedButton onClick={nextButtonClickHandler}>Got it</RedButton>
        </div>

        <CallMeBackForm></CallMeBackForm>
      </div>
    </div>
  );
};

export default withRouter(NewCustomerDocumentNotes);
